// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.timeline-container:hover .timeline-content[data-v-d8722eec]:not(:hover) {\n  background-color: #e2e2e2 !important;\n  transition: 0.6s;\n}\n.timeline-fixed-width[data-v-d8722eec] {\n  height: 190px;\n}\n.timeline-fixed-size[data-v-d8722eec] {\n  aspect-ratio: 1.5 / 1;\n}\n.w-0[data-v-d8722eec] {\n  width: 0;\n}\n.border-dashed[data-v-d8722eec] {\n  border: 1px blue dashed;\n}\n", ""]);
// Exports
module.exports = exports;
